<template>
  <div id="parkReserveList">
    <el-row>
      <el-col :span="24"
              class="titleLine">
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       class="titleLine1">
          <el-breadcrumb-item>月车</el-breadcrumb-item>
          <el-breadcrumb-item>月车管理</el-breadcrumb-item>
          <el-breadcrumb-item>预约车辆管理</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-form :inline="true"
             label-width="80px">
      <el-row>
        <el-col :span="24">
          <el-form-item label="客户::">
            <el-select v-model="pageSearch.fCustID"
                       clearable
                       filterable
                       placeholder="请选择客户"
                       style="width:200px;"
                       @change="loadPark">
              <el-option v-for="item in cust_list"
                         :key="item.fCustID"
                         :label="item.unionName"
                         :value="item.fCustID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="场库::">
            <el-select v-model="pageSearch.fParkID"
                       filterable
                       placeholder="请选择场库"
                       style="width:200px;"
                       clearable>
              <el-option v-for="item in park_list"
                         :key="item.fParkID"
                         :label="item.fParkName"
                         :value="item.fParkID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="车牌::">
          <el-input placeholder="请输入车牌"
                    v-model="pageSearch.searchKeyWord"
                    class="search">
          </el-input>
        </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-form-item label="开始时间::">
          <el-date-picker v-model="startTime"
                          style="width:200px"
                          type="datetime"
                          :clearable="true"
                          format="yyyy-MM-dd HH:mm:ss"
                          placeholder="选择开始时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间::">
          <el-date-picker v-model="endTime"
                          style="width:200px"
                          :clearable="true"
                          format="yyyy-MM-dd HH:mm:ss"
                          type="datetime"
                          placeholder="选择结束时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="">
            <el-checkbox v-model="pageSearch.isEffective" style="padding-left:38px;">预约有效状态</el-checkbox>
          </el-form-item>
        <el-form-item>
          <el-button type="primary"
                     size="small"
                     icon="el-icon-search"
                     @click="page_list">查询</el-button>
          <el-button type="success"
                     size="small"
                     icon="el-icon-share"
                     :loading="export_loading"
                     v-if="is_export"
                     @click="exportData">{{export_msg}}</el-button>
        </el-form-item>
      </el-row>
    </el-form>
    <el-row>
      <el-col :span="24"
              style="height: 5px"></el-col>
    </el-row>
    <el-row class="tabRow">
        <el-table :data="pageData"
                  :height="tableHeight"
                  highlight-current-row
                  v-loading="loading"
                  border
                  stripe
                  style="width: 100%">
          <el-table-column width="50"
                            type="index"
                            :index="indexMethod"
                            label="序号">
          </el-table-column>
          <el-table-column prop="fCustNo"
                            width="80"
                            label="客户编号">
          </el-table-column>
          <el-table-column prop="fCustName"
                            width="125"
                            label="客户名称">
          </el-table-column>
          <!--<el-table-column prop="fParkNo"
                            width="80"
                            label="场库编号">
          </el-table-column>
          <el-table-column prop="fParkName"
                            width="115"
                            label="场库名称">
          </el-table-column>-->
          <el-table-column prop="fPlateCode"
                            width="100"
                            label="车牌号码">
          </el-table-column>
          <el-table-column prop="fCellPhone"
                            width="115"
                            label="手机号码">
          </el-table-column>
          <el-table-column prop="fOpLastTime"
                            width="160"
                            label="车主预约操作时间">
          </el-table-column>
          <el-table-column prop="fDateBeg"
                            width="160"
                            label="有效起始时间">
          </el-table-column>
          <el-table-column prop="fDateEnd"
                            width="160"
                            label="有效结束时间">
          </el-table-column>
          <el-table-column prop="fFloorName"
                            width="80"
                            label="楼层名称">
          </el-table-column>
          <el-table-column prop="fAreaName"
                            width="80"
                            label="区域名称">
          </el-table-column>
          <el-table-column prop="fPlaceNo"
                            width="80"
                            label="车位编号">
          </el-table-column>
          <el-table-column prop="fSysName"
                            width="105"
                            label="数据来源">
          </el-table-column>
          <el-table-column prop="fReserveStatus"
                            label="预约状态">
          </el-table-column>
          <el-table-column prop="fCarTypeID"
                            label="车辆类型">
          </el-table-column>
          <el-table-column prop="fProviderID"
                            width="105"
                            label="预约下发方">
          </el-table-column>
          <!--<el-table-column prop="fCarStatus"
                            label="车辆进出场状态">
          </el-table-column>-->
          <el-table-column prop="fReserveType"
                            label="预约类型">
          </el-table-column>
          <el-table-column prop="fResType"
                            label="预约类型">
          </el-table-column>
          <el-table-column prop="fCarStatus"
                            label="车辆进出场状态">
          </el-table-column>
          <el-table-column prop="fReserveAmount"
                            align="right"
                            label="支付金额">
          </el-table-column>
          <!--<el-table-column label="操作"
                            fixed="right"
                            align="center"
                            width="90">
            <template slot-scope="scope">
              <el-button size="mini"
                          type="success"
                          @click="handleInfo(scope.$index, scope.row)">查看</el-button>
            </template>
          </el-table-column>-->
        </el-table>
      <el-col :span="24">

      </el-col>
    </el-row>
    <el-row class="pagination">
      <el-col :span="24">
        <div class="block">
          <el-pagination @current-change="handleCurrentChange"
                         @size-change="handleSizeChange"
                         :current-page="pageSearch.pageIndex"
                         :page-size="pageSearch.pageSize"
                         :page-sizes="[10, 20, 50, 100]"
                         background
                         layout=" total, sizes,prev, pager, next, jumper"
                         :total="pageCount"
                         v-if="pageCount>0">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import * as park from '../../api/park'
import * as user from '../../api/user'
import { mapActions } from 'vuex'
import { deployment as api } from '@/api/deploymentCar'
import $ from 'jquery'
const delay = (function () {
  let timer = 0
  return function (callback, ms) {
    clearTimeout(timer)
    timer = setTimeout(callback, ms)
  }
})()
export default {
  data () {
    return {
      is_export: false,
      tableHeight: 0,
      loading: false,
      export_loading: false,
      export_msg: '导出',
      reportActiveName: 'pageData',
      pageData: [],
      cust_list: [],
      park_list: [],
      pageCount: 0,
      startTime: '',
      endTime: '',
      pageSearch: {
        isExport: 0,
        pageIndex: 1,
        pageSize: 20,
        fCustID: '',
        fParkID: '',
        fstartTime: '',
        fendTime: '',
        searchKeyWord: '',
        isEffective: true
      }
    }
  },
  methods: {
    ...mapActions([
      'getCardGroupByCustId'
    ]),
    // 搜索词搜索
    wordSearch () {
      delay(() => {
        this.page_list()
      }, 1000)
    },
    initData () {
      this.pageSearch.pageIndex = 1
      this.pageSearch.fstartTime = ''
      if ((this.startTime || '').toString().trim().length > 0) {
        this.pageSearch.fstartTime = this.$dateFormat(this.startTime, 'yyyy-MM-dd hh:mm:ss')
      }
      this.pageSearch.fendTime = ''
      if ((this.endTime || '').toString().trim().length > 0) {
        this.pageSearch.fendTime = this.$dateFormat(this.endTime, 'yyyy-MM-dd hh:mm:ss')
      }
      this.pageSearch.isExport = 0
      api.getParkReserveList(this.pageSearch).then(res => {
        this.loading = false
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.pageData = data.Data.data
            this.pageCount = data.Data.count
          } else {
            if (data.Msg.length > 0) {
              this.$message.error(data.Msg)
            } else {
              this.$message.error('提示：加载在场数据失败')
            }
            // this.$message.error('提示：加载在场数据失败')
          }
        }
      })
    },
    page_list (index) {
      if (index && index >= 1) {
        this.pageSearch.pageIndex = index
      } else {
        this.pageSearch.pageIndex = 1
      }
      this.loading = true
      this.pageSearch.fstartTime = ''
      if ((this.startTime || '').toString().trim().length > 0) {
        this.pageSearch.fstartTime = this.$dateFormat(this.startTime, 'yyyy-MM-dd hh:mm:ss')
      }
      this.pageSearch.fendTime = ''
      if ((this.endTime || '').toString().trim().length > 0) {
        this.pageSearch.fendTime = this.$dateFormat(this.endTime, 'yyyy-MM-dd hh:mm:ss')
      }
      this.pageSearch.isExport = 0
      api.getParkReserveList(this.pageSearch).then(res => {
        this.loading = false
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.pageData = data.Data.data
            this.pageCount = data.Data.count
          } else {
            if (data.Msg.length > 0) {
              this.$message.error(data.Msg)
            } else {
              this.$message.error('提示：加载在场数据失败')
            }
            // this.$message.error('提示：加载在场数据失败')
          }
        }
      })
    },
    exportData () {
      if ((this.pageSearch.fCustID || '').trim().length <= 0) {
        this.$message.error('提示：请先选择客户')
        return false
      }
      this.export_loading = true
      this.export_msg = '导出中……'
      var custArr = (this.cust_list || []).filter((item) => {
        return item.fCustID === this.pageSearch.fCustID
      })
      var fileName = custArr.length > 0 ? custArr[0].unionName : ''
      this.pageSearch.fstartTime = ''
      if ((this.startTime || '').toString().trim().length > 0) {
        this.pageSearch.fstartTime = this.$dateFormat(this.startTime, 'yyyy-MM-dd hh:mm:ss')
      }
      this.pageSearch.fendTime = ''
      if ((this.endTime || '').toString().trim().length > 0) {
        this.pageSearch.fendTime = this.$dateFormat(this.endTime, 'yyyy-MM-dd hh:mm:ss')
      }
      this.pageSearch.isExport = 1
      api.getParkReserveList(this.pageSearch).then(res => {
        this.export_loading = false
        this.export_msg = '导出'
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            if (data.Data) {
              this.fileDownload(data.Data, fileName + '_预约车辆管理数据.xls')
            }
          } else {
            this.$message.error('提示：' + data.Msg)
          }
        }
      })
    },
    viewParkInfo (row) {
      this.$refs.childPark.viewPark(row, true, row.fParkID)
    },
    viewCard (row) {
      this.$refs.childCard.viewCard(row, true)
    },
    loadPark (fCustID) {
      this.pageSearch.fParkID = ''
      this.park_list = []
      // 加载在场数据列表
      // this.page_list()
      if (!fCustID) { return }
      // 加载场库
      park.getParkList({ fCustID: fCustID }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.park_list = data.Data
          } else {
            this.$message.error('提示：加载场库列表失败')
          }
        }
      })
    },
    changeChannel (val) {
      // 加载在场数据列表
      this.page_list()
    },
    init () {
      var today = new Date()
      this.startTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0)
      this.endTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59)
      park.getCustByGroup({ fCustTypeID: 0 }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.cust_list = data.Data
            if (this.cust_list && this.cust_list.length === 1) {
              this.pageSearch.fCustID = this.cust_list[0].fCustID
              this.loadPark(this.pageSearch.fCustID)
            }
          } else {
            this.$message.error('提示：加载客户列表失败')
          }
        }
      })
    },
    indexMethod (index) {
      return this.pageSearch.pageSize * (this.pageSearch.pageIndex - 1) + index + 1
    },
    handleSizeChange (val) {
      this.pageSearch.pageSize = val
      this.page_list(this.pageSearch.pageIndex)
    },
    handleCurrentChange (val) {
      this.page_list(val)
    },
    tabClick () {
      this.pageCount = 0
      this.page_list()
    },
    handleInfo (index, row) {
      this.$refs.child.handleInfo(row)
    },
    setImgHeight () {
      var formHeight = $('.form_right').height()
      var fplateHeight = $('.fplate_info .el-image').height()
      var carImgHeight = $('.car_img .img').height()
      if (formHeight && fplateHeight > 0) {
        var height = (formHeight - fplateHeight - carImgHeight) / 2
        $('.fplate_info').css({ 'margin-top': height + 'px', 'margin-bottom': height + 'px' })
      }
    },
    setTableHeight (obj) {
      let clientHeight = obj.getRJPageSize.getRJPageSize()[3] - 280
      obj.tableHeight = clientHeight
      this.setImgHeight()
    }
  },
  created () {
    user.getCurrentUserPers({ perTypeId: 36000 }).then(res => {
      if (res && res.data) {
        var data = res.data
        if (data.IsOk) {
          if (data.Data) {
            this.is_export = data.Data.data.is_export
          }
        } else {
          this.$message.error('提示：加载当前用户权限信息失败')
        }
      }
    })
  },
  mounted () {
    window.onresize = () => {
      this.setTableHeight(this)
    }
    this.init()
    this.initData()
  },
  updated () {
    this.setTableHeight(this)
  }
}
</script>
<style>

/* end */
</style>
<style scoped>
.el-form-item {
  margin-bottom: 5px;
}
.pagination-left {
  float: left;
}
.pagination-left > label {
  font-size: 13px;
  padding: 2px 5px;
  color: #303133;
  font-weight: 700;
  line-height: 28px;
  height: 28px;
}
.el-pagination {
  float: right;
}

.pagination {
  /* text-align: right; */
  padding-top: 5px;
}
.search {
  width: 200px;
}
</style>



// WEBPACK FOOTER //
// src/view/card/parkReserveList.vue